import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../hooks/useGetHook";
import usePatchHook from "../../hooks/usePatchHook";
import Spinner from "../../shared/Spinner";
import { IPopup } from "../../types/interface";

const EditPopupModalComponent = loadable(
  () => import("../../components/PopupModal/Edit")
);

export default function EditPages() {
  const { id } = useParams();

  const { data: popupInfo, isLoading: isGettingPopupInfo } = useGetHook<IPopup>(
    {
      url: `${APIS.POPUP}${id}`,
      queryKey: [`get-popup-details-${id}`],
    }
  );

  const { mutateAsync: updatePopup, isLoading: isUpdatingPopup } = usePatchHook(
    {
      queryKey: [`update-page-details-${id}`],
      navigateURL: "/website-builder/popup-modal",
    }
  );

  const handleUpdate = async (
    data: IPopup,
    setError: UseFormSetError<IPopup>
  ): Promise<void> => {
    try {
      const url = `${APIS.POPUP}${id}/`;
      await updatePopup({
        url,
        formData: {
          ...data,
        },
        setError,
      });
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  return (
    <>
      {isGettingPopupInfo ? (
        <Spinner />
      ) : (
        <EditPopupModalComponent
          handleUpdate={handleUpdate}
          isUpdatingPopup={isUpdatingPopup}
          popupInfo={popupInfo}
        />
      )}
    </>
  );
}
